@switch (type()) { @case ('parametersLabel') {
<mat-form-field appearance="fill" class="w-100">
  @if (formControl) {
  <input matInput type="text" [placeholder]="label()" [formControl]="formControl" />
  }
</mat-form-field>
@if (formControl.hasError('required') && formControl.dirty) {
<mat-error class="error-position-fix">
  {{ 'VOUCHER.ATP.INVALID_PARAMETER' | translate }}
</mat-error>
} } @case ('parameters') {
<mat-form-field appearance="fill" class="w-100">
  @if (formControl) {
  <input matInput type="text" [placeholder]="label()" [formControl]="formControl" />
  }
</mat-form-field>
@if (formControl.hasError('required') && formControl.dirty) {
<mat-error class="error-position-fix">
  {{ 'VOUCHER.ATP.INVALID_PARAMETER' | translate }}
</mat-error>
} } @case ('secureParameters') {
<mat-form-field appearance="fill" class="w-100">
  @if (formControl) {
  <input matInput type="password" [placeholder]="label()" [formControl]="formControl" />
  }
</mat-form-field>
@if (formControl.hasError('required') && formControl.dirty) {
<mat-error class="error-position-fix">
  {{ 'VOUCHER.ATP.INVALID_PARAMETER' | translate }}
</mat-error>
} } @case ('enabledModules') {
<mat-form-field appearance="fill" class="w-100">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="formControl" [multiple]="true">
    @for (modulo of Object.values(EnabledModulesEnum); track modulo) {
    <mat-option [value]="modulo">
      {{ modulo }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
} @case ('contextName') {
<mat-form-field appearance="fill" class="w-100">
  <mat-label>{{ label() }}</mat-label>
  @if (formControl) {
  <input matInput type="text" [placeholder]="label()" [formControl]="formControl" />
  }
</mat-form-field>
@if (formControl.hasError('required') && formControl.dirty) {
<mat-error class="error-position-fix">
  {{ 'VOUCHER.ATP.INVALID_PARAMETER' | translate }}
</mat-error>
} } }
